import { FeaturesEnabledResponse } from "../../Types/FeaturesEnabled";

export interface UsageTableRow extends Record<string, string | boolean> {
  id: string;
  clientName: string;
  siteUrl: string;
}

const getColumnUseRate = (data: UsageTableRow[], property: string) => {
  const total = data.length;
  const enabled = data.filter((item) => item[property]).length;
  return `${((enabled / total) * 100).toFixed(1)}%`;
};

const usageTableData = (data?: FeaturesEnabledResponse) => {
  if (!data) return [];
  const features = data.features;
  return data.clients.map((item) => {
    const clientFeatures: Record<string, boolean> = {};
    features.forEach((feature) => {
      clientFeatures[feature] = item.enabledFeatures.some((f) => f === feature);
    });
    return {
      id: item.clientId,
      clientName: item.clientName,
      siteUrl: item.siteUrl,
      ...clientFeatures,
    } as UsageTableRow;
  });
};

const sortUsageData = (data: UsageTableRow[], property: string, ascending: boolean) =>
  [...data].sort((a, b) => {
    const valueA = a[property];
    const valueB = b[property];

    if (typeof valueA === "string" && typeof valueB === "string") {
      return ascending
        ? valueA.localeCompare(valueB, undefined, { sensitivity: "base" })
        : valueB.localeCompare(valueA, undefined, { sensitivity: "base" });
    }

    if (typeof valueA === "boolean" && typeof valueB === "boolean") {
      const primaryComparison = ascending ? Number(valueA) - Number(valueB) : Number(valueB) - Number(valueA);

      if (primaryComparison === 0) {
        return a.clientName.localeCompare(b.clientName, undefined, { sensitivity: "base" });
      }
      return primaryComparison;
    }

    if (valueA < valueB) {
      return ascending ? -1 : 1;
    }
    if (valueA > valueB) {
      return ascending ? 1 : -1;
    }
    return 0;
  });

export { getColumnUseRate, usageTableData, sortUsageData };
